import GradientWaves from './react-bits/GradientWaves';
import { useMotionPreferences } from './MotionPreferences';
import '../styles/components/site-background.css';

export default function SiteBackground() {
  const { paused } = useMotionPreferences();

  return <div className="site-background" aria-hidden="true">
    <GradientWaves paused={paused} speed={0.07} />
  </div>;
}
